import classNames from 'classnames'
import { ContextMenu } from '@winnin/winnin_ui.components.context-menu'
import { Icon } from '@winnin/winnin_ui.components.icon'

import { Folder } from 'assets/icons'
import { RCTooltip } from 'components/RCTooltip'
import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import type { IDashboardFolder } from './dashboard-folder.types'
import './dashboard-folder.styles.scss'

export const DashboardFolderView = ({ dashboardCount, folderName, actionOptions, isSelected }: IDashboardFolder) => {
  const t = useTranslate()
  return (
    <div className={classNames(['DashboardFolder', { isSelected }])}>
      <div className="iconWrapper">
        <Folder height="24px" width="24px" color="var(--color_primary_500)" />
      </div>
      <div className="textContent">
        <RCTooltip tooltipMessage={folderName}>
          <p>{folderName}</p>
        </RCTooltip>
        <span>{t(TOLGEE_GLOBALS.dashboardWithPlural({ dashboardCount }))}</span>
      </div>
      {Boolean(actionOptions?.length) && (
        <div className="optionsWrapper">
          <ContextMenu menuItems={actionOptions}>
            <Icon icon="verticalDots" fill="var(--color_neutral_800)" />
          </ContextMenu>
        </div>
      )}
    </div>
  )
}
